import { useCallback } from "react"
import { useActiveWeb3React } from '../'
import useYam from "../bakery/useYam"
import { cancelBidToken } from '../../sushi/utils'
import { cancelBidToken as cancelBidToken2 } from '../../sushi/exchangeNFTs'

import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { userNftAddress } from '../../userType/userNftAddress'
import { userTokenAddress } from '../../userType/userTokenAddress'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { userExchangeNFTContract } from "../../userType/userExchangeNFTContract"
import { userV3NFTContract } from "../../userType/userV3NFTContract"

const useCancelBid = (tokenId: string, nftType?: string, tokenName?: string) => {
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  let exchangeNFTContract: any 
  let isMultiTokenNft = false

  if(nftType && MARKETTYPE.hasOwnProperty(nftType)){
    exchangeNFTContract = userBidNFTContract(sushi, nftType)
  }else if(nftType && MARKETMULTITOKEN.hasOwnProperty(nftType)){
    exchangeNFTContract = multiTokenExchangeNftContract(sushi, nftType)
    isMultiTokenNft = true
  }else if(nftType && MARKETTYPEV1.hasOwnProperty(nftType)){
    exchangeNFTContract = userExchangeNFTContract(sushi, nftType)
  }else if(nftType && MARKETTYPEV3.hasOwnProperty(nftType)){
    exchangeNFTContract = userV3NFTContract(sushi, nftType)
    isMultiTokenNft = true
  }

  const cancel = useCallback(async () => {
    try {
      let tx
      if(!isMultiTokenNft){
        tx = await cancelBidToken(exchangeNFTContract, tokenId, account)
      }else{
        let nftAddress = userNftAddress(sushi, nftType)
        let quoteAddress = userTokenAddress(sushi, tokenName)
        tx = await cancelBidToken2(exchangeNFTContract, nftAddress, tokenId, quoteAddress, account)
      }
      return tx
    } catch (e) {
      return false
    }
  }, [account, exchangeNFTContract, tokenId, isMultiTokenNft,nftType,sushi,tokenName])

  return cancel
}
export default useCancelBid